module.exports = __webpack_public_path__ + "img/remote-manager.6d80d77d.svg";